<template>
  <div class="qty-bar-vertical">
    <div class="qty-bar-label">
      <span class="qty-bar-label-text">Qty</span>
      <span
        class="qty-bar-value"
        :class="{ 'has-value': displayQty !== '-' }"
      >
        {{ displayQty }}
      </span>
    </div>
    <div class="qty-bar-buttons">
      <button
        class="qty-btn qty-btn-clear"
        @click="clearQuantity"
      >
        C
      </button>
      <button
        v-for="num in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]"
        :key="num"
        class="qty-btn"
        @click="selectQuantity(num)"
      >
        {{ num }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuantityBar",
  data() {
    return {
      qtyInput: "",
      selectedQty: null
    };
  },
  computed: {
    displayQty() {
      return this.qtyInput !== "" ? this.qtyInput : "-";
    }
  },
  methods: {
    selectQuantity(num) {
      if (this.qtyInput.length >= 2) {
        this.qtyInput = String(num);
      } else {
        this.qtyInput += String(num);
      }

      const qty = parseInt(this.qtyInput, 10);

      if (qty > 0) {
        this.selectedQty = qty;
        this.$emit("quantity-selected", qty);
      } else {
        this.selectedQty = null;
      }
    },
    clearQuantity() {
      this.qtyInput = "";
      this.selectedQty = null;
      this.$emit("quantity-selected", null);
    },
    resetQuantity() {
      this.qtyInput = "";
      this.selectedQty = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.qty-bar-vertical {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f8f9fa;
  border-left: 2px solid #dee2e6;
  border-right: 2px solid #dee2e6;
  padding: 15px 8px;
  gap: 10px;
  height: 100%;
  width: 80px;
}

.qty-bar-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 700;
  color: #495057;
  text-align: center;
  padding-bottom: 10px;
  border-bottom: 2px solid #dee2e6;
  width: 100%;
  margin-bottom: 5px;
  gap: 4px;
}

.qty-bar-label-text {
  font-size: 14px;
  color: #6c757d;
}

.qty-bar-value {
  font-size: 22px;
  min-height: 28px;
  line-height: 1.2;
  color: #adb5bd;

  &.has-value {
    color: #2889FA;
  }
}

.qty-bar-buttons {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  align-items: center;
}

.qty-btn {
  width: 60px;
  height: 52px;
  border: 2px solid #ced4da;
  background: #ffffff;
  border-radius: 8px;
  font-size: 20px;
  font-weight: 600;
  color: #495057;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    border-color: #2889FA;
    background: #e7f3ff;
    color: #2889FA;
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }
}

.qty-btn-clear {
  font-size: 18px;
  color: #6c757d;
  background: #e9ecef;

  &:hover {
    border-color: #dc3545;
    background: #fde8ea;
    color: #dc3545;
  }
}

@media (max-width: 767.98px) {
  .qty-bar-vertical {
    flex-direction: row;
    height: auto;
    width: 100%;
    padding: 10px 12px;
    border-left: none;
    border-right: none;
    border-top: 2px solid #dee2e6;
    border-bottom: 2px solid #dee2e6;
  }

  .qty-bar-label {
    font-size: 14px;
    min-width: 50px;
    border-bottom: none;
    border-right: 2px solid #dee2e6;
    padding-bottom: 0;
    padding-right: 10px;
    margin-bottom: 0;
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .qty-bar-buttons {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
    flex: 1;
  }

  .qty-btn {
    width: 45px;
    height: 45px;
    font-size: 16px;
  }
}
</style>
